export const MAIN_CLASS_NAME = 'project-page';
export const CONTENT_CLASS_NAME = `${MAIN_CLASS_NAME}__content`;

export const INGESTION_STATE_REFRESH_INTERVAL = 5000;
export const TEXT_HTML_MIME = 'text/html';

export const PROJECT_AVATAR_NAME_DEFAULT = 'default';
export const USER_AVATAR_NAME_DEFAULT = 'user';
